/**
 * Napaka strežnika ({@code NapakaOdgovor}: koda, sporočilo za uporabnika in napake po poljih – ime lastnosti →
 * sporočilo, prikaže se ob polju) ali povezave.
 */
export class NapakaApi extends Error {
  readonly koda: string;
  readonly status: number;
  readonly polja: Record<string, string>;

  constructor(sporocilo: string, koda: string, status: number, polja: Record<string, string> = {}) {
    super(sporocilo);
    this.name = 'NapakaApi';
    this.koda = koda;
    this.status = status;
    this.polja = polja;
  }
}

export const NAPAKA_POVEZAVE = 'POVEZAVA';

type NapakaOdgovor = { koda?: string; sporocilo?: string; polja?: Record<string, string> | null };

/** {@link NapakaApi} iz že prebranega telesa odgovora (NapakaOdgovor, če ga je strežnik vrnil) in statusa. */
export function napakaApi(telo: unknown, status: number): NapakaApi {
  const n: NapakaOdgovor = telo && typeof telo === 'object' ? (telo as NapakaOdgovor) : {};
  return new NapakaApi(
    n.sporocilo ?? `Napaka strežnika (${status}). Poskusite znova.`,
    n.koda ?? 'NAPAKA',
    status,
    n.polja ?? {},
  );
}

/** Iz neprebranega odgovora z napako (navaden fetch) naredi {@link NapakaApi}. */
export async function izOdgovora(odgovor: Response): Promise<NapakaApi> {
  let telo: unknown = null;
  try {
    telo = await odgovor.clone().json();
  } catch {
    // ni JSON (npr. napaka posrednika)
  }
  return napakaApi(telo, odgovor.status);
}

export function napakaPovezave(): NapakaApi {
  return new NapakaApi('Strežnik ni dosegljiv. Preverite povezavo in poskusite znova.', NAPAKA_POVEZAVE, 0);
}

/** Sporočilo za uporabnika iz poljubne napake. */
export function sporocilo(napaka: unknown): string {
  if (napaka instanceof NapakaApi) {
    return napaka.message;
  }
  return 'Prišlo je do nepričakovane napake. Poskusite znova.';
}
